import cookies from 'browser-cookies';
import Future from 'fluture';

export default function createSaveInteraction() {
  return function saveInteraction(expires) {
    cookies.set(
      'pwinteraction',
      'yes',
      {
        expires,
        domain: window.utag.cfg.domain,
      }
    );

    return Future.of(true);
  }
}


// WEBPACK FOOTER //
// ./src/infrastructure/saveInteraction.js